import Route from 'cio/routes/base';
import TransactionalMessageOverviewMetricsController from 'cio/pods/transactional/message/overview/metrics/controller';
import TransactionalMessageModel from 'cio/models/transactional-message';
import Transition from '@ember/routing/-private/transition';

export default class TransactionalMessageOverviewMetrics extends Route {
  setupController(
    controller: TransactionalMessageOverviewMetricsController,
    model: TransactionalMessageModel,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);
    controller.setDefaults();
  }
}
